// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"SearchInputIcon_iconContainer__z7b2G","icon":"SearchInputIcon_icon__t1nGp","selectSearch":"SearchInputIcon_selectSearch__Gdqtn"};